import React from 'react'
import ReportSubtitle from 'components/Text/ReportSubtitle'
import ReportSubtitleV1 from 'components/Text/ReportSubtitleV1'
import useLanguage from 'features/languageReport/useLanguage'
import useStyles from 'components/molcules/ProfitSummaryReport/useStyles'
import {simpleSanitizeHTML} from 'helpers/analysisHelper'

export default function EEGSummaryBrain3DAPI(props: {
  threeDimensionImage: string
  index: number
  isSummary?: boolean
}) {
  const {threeDimensionImage, index, isSummary} = props
  const {textEegAPI} = useLanguage('eeg')
  const classes = useStyles()

  return (
    <div className={classes.eeg}>
      {isSummary ? (
        <ReportSubtitleV1 number={`${index}`}>
          {
            textEegAPI?.brain_aging?.basic?.section?.three_dimensional_graph
              ?.title
          }
        </ReportSubtitleV1>
      ) : (
        <ReportSubtitle number={`${index}`}>
          {
            textEegAPI?.brain_aging?.basic?.section?.three_dimensional_graph
              ?.title
          }
        </ReportSubtitle>
      )}

      <div className={classes.p_brain3D}>
        <div className='Brain-3d-image'>
          {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
          <img src={threeDimensionImage} alt='brain wave analysis 3d image' />
        </div>
        <div className='Brain-3d-info'>
          <div className='Title'>
            {
              textEegAPI?.brain_aging?.basic?.section?.three_dimensional_graph
                ?.description?.main
            }
          </div>
          <div className='Desc'>
            <div // @ts-ignore
              // eslint-disable-next-line
              dangerouslySetInnerHTML={{
                __html: simpleSanitizeHTML(
                  String(
                    textEegAPI?.brain_aging?.basic?.section
                      ?.three_dimensional_graph?.description?.sub[0],
                  ),
                ),
              }}
            />
            <br />
            <div // @ts-ignore
              // eslint-disable-next-line
              dangerouslySetInnerHTML={{
                __html: simpleSanitizeHTML(
                  String(
                    textEegAPI?.brain_aging?.basic?.section
                      ?.three_dimensional_graph?.description?.sub[1],
                  ),
                ),
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
